import React from 'react'

// TODO: Move this to `context/` dir

export interface ThemeData {
  ajaxurl: string
  ajaxnonce: string
  stripe: string
  reCAPTCHA: string
}

// TODO: Find a better way to hydrate the application with env vars / dynamic data
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const themeData = typeof window !== 'undefined' ? window?.env : {}

export const ThemeContext = React.createContext<ThemeData>(
  themeData as ThemeData // default value
)
